export const basicImage = "/src/img/logo/transparant_logo.png"

export const SITE_NAME = "BigBangX";
export const SITE_URL = "https://bigbangx.org/";
export const SITE_TITLE = "BigBangX";
export const SITE_DESCRIPTION =
    "Welcome to the future of Web3 Marketplace with onchain gaming, NFTs and cros-chain trading uniting together";
export const SITE_OG_IMAGE = "https://gcdnb.pbrd.co/images/71fEGAJVxI8R.png?o=1";
export const SITE_OG_IMAGE_WIDTH = "1667";
export const SITE_OG_IMAGE_HEIGHT = "871";
export const SITE_TWITTER = "@bigbangx";

export enum CHAINS {
    testnet = "rebel-2",
    mainnet = "columbus-5",
}

export const CHAINS_SELECTED = "chain_selected";
export const URL = "https://api-bigbangx.garuda-defi.org";
export const CHAINS_USAGE = "columbus-5";

export const GAS_PRICE = "28.325";
export const DENOM = "uluna";
export const MULTIPLIER = 1.3;
export const TAX = 0.005;
export const RPC_URLS = {
    [CHAINS.testnet]: "https://rpc.luncblaze.com:443",
    [CHAINS.mainnet]: "https://terra-classic-rpc.publicnode.com:443",
};;
export const WC_PROJECT_ID = "90bd29bd5f8f1cf682ab8d4b07e8ff4d";
export const WALLET_ID_KEY = "WALLET_ID";
export const WALLET_TYPE_KEY = "WALLET_TYPE";


export const CLASSIC_CHAIN_ID = "columbus-5";
export const CLASSIC_GAS_PRICE = "28.325";
export const CLASSIC_DENOM = "uluna";
